import type { BuildIntake } from './types';
import { getConsultationStrategyPackage, isConsultationProjectType } from './types';

export function getBuildIntakeErrors(intake: BuildIntake): string[] {
  const errors: string[] = [];

  if (!intake.contactName?.trim()) {
    errors.push('Your name is required');
  }
  if (!intake.email?.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(intake.email.trim())) {
    errors.push('A valid email is required');
  }
  if (!intake.description?.trim() || intake.description.trim().length < 20) {
    errors.push('Project description must be at least 20 characters');
  }
  if (isConsultationProjectType(intake.projectType)) {
    const strategy = getConsultationStrategyPackage(intake.consultationMinutes);
    if (!strategy && intake.consultationHours < 1) {
      errors.push('Select a strategy session');
    }
  }

  return errors;
}
